import Image from 'next/image'

import type { SlideItem } from '@/shared/components/slider/view'
import { Caption } from '@/shared/components/typography'

interface ModalSlideProps {
  item: SlideItem
  isNotNaverInApp?: boolean
}

const ModalSlide = ({ item, isNotNaverInApp }: ModalSlideProps) => {
  const hasDesc = 'pictureDesc' in item

  return (
    <div className={`relative ${isNotNaverInApp ? 'h-[100dvh]' : 'h-screen'} h-[100dvh] w-full shrink-0`}>
      <Image
        alt="주차장 사진"
        fill
        src={'fileName' in item ? item.fileName : 'file_name' in item ? item['file_name'] : ''}
        sizes="100%"
        style={{ objectFit: 'contain' }}
        draggable={true}
      />

      {hasDesc && item.pictureDesc && (
        <div className="absolute bottom-0 left-0 right-0 z-10 flex items-center bg-dim-050 p-4">
          <Caption level="caption1" color="white">
            {item.pictureDesc}
          </Caption>
        </div>
      )}
    </div>
  )
}

export default ModalSlide
